module.exports = {
    "add.topic": "Add Topic",
    "topic.title": "Title",
    "topic.tag": "Tag, press enter to add",
    "tip.input.title": "title required",
    "my.topic": "My Topic",
    "reply.topic": "Replied Topic",
    "new.topic": "New Topic",
    "search.placeholder": "Search...",
    "content.length": "The length of content is too short",
    "content.length.max": "The length of content is too large",
    "tag.length": "The length of characters must be less than {{max}}",
    "tag.count": "The count of tags must be less than {{max}}",
    "all": "All",
    "essence.title": "Essence"
}


// WEBPACK FOOTER //
// ./src/pages/home/i18n/locale.en.js